export default "__VITE_ASSET__Bd4DgOIC__"